import React from "react";
import { AttrTypeName } from "src/types/AttrType";
import {
  FormObjectSection,
  FormObjectSectionsStore,
} from "src/components/Forms/FormObjectSection";
import { observer } from "mobx-react-lite";
import { DrawTab } from "./DrawTab";
import {
  ZSchedSettingsGroup,
  ZSchedulingSettings,
} from "../../SchedulingTypes";
import { SchedulingObjType } from "../SchedulingSettingsStore";

interface PropsGroupFields {
  tabKey: keyof ZSchedulingSettings;
  objType: SchedulingObjType;
  store: FormObjectSectionsStore<SchedulingObjType>;
  title?: string;
}

export const GroupFields: React.FC<PropsGroupFields> = observer(
  ({ tabKey, objType, store, title }) => {
    const isGroupTab =
      tabKey === "groupSettings" || tabKey === "groupTemplateSettings";
    if (!isGroupTab) return null;
    const fieldName = (
      name: keyof ZSchedSettingsGroup,
    ): [typeof tabKey, keyof ZSchedSettingsGroup] => [tabKey, name];
    return (
      <DrawTab>
        <FormObjectSection<ZSchedulingSettings, SchedulingObjType>
          store={store}
          objKey={fieldName("templateObjectId")}
          objType={objType}
          title={title}
          attrTitle="Выберите атрибуты:"
          attrs={[
            {
              attrKey: fieldName("nameAttributeId"),
              attrLabel: "Название",
              attrType: AttrTypeName.dictSingle,
            },
            {
              attrKey: fieldName("taskListAttributeId"),
              attrLabel: "Список задач, включенных в группу",
              attrType: AttrTypeName.childEntities,
            },
          ]}
        />
        <FormObjectSection<ZSchedulingSettings, SchedulingObjType>
          store={store}
          objKey={fieldName("templateObjectId")}
          objType={objType}
          isObjSelect={false}
          attrTitle="Выберите атрибуты принадлежности группы:"
          attrs={[
            {
              attrKey: fieldName("relationPlanTemplateAttributeId"),
              attrLabel: "К плану",
              attrType: AttrTypeName.object,
            },
          ]}
        />
      </DrawTab>
    );
  },
);
